// Module
var code = `<div class="modal fade" id="confirmModal" tabindex="-1" role="dialog" data-bind="showModal: show">
        <div class="modal-dialog">
            <div class="modal-content">
                    <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" xdata-bind="click: clear">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <h4 class="modal-title" data-bind="label: 'cc_Request_Status_Change'">Request Status Change</h4>
                        </div>
                 <div class="modal-body">
                     <p data-bind="text: message"></p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal" data-bind="click: closeConfirm, label: 'cc_Close'"></button>
                </div>
            </div>
        </div>
    </div>`;
// Exports
module.exports = code;